import { Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import ThankYouPage from "./pages/ThankYouPage";
import "./App.css";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
    </Routes>
  );
}

export default App;
